import slide1 from './assets/slide-1.jpg';
import slide2 from './assets/slide-2.jpg';
import slide3 from './assets/slide-3.jpg';
import boots from './assets/categories/boots.jpg';
import dress from './assets/categories/dress.jpg';
import outerwear from './assets/categories/outerwear.jpg';
import prod1 from './assets/products/prod1.jpg';
import prod2 from './assets/products/prod2.jpg';
import prod3 from './assets/products/prod3.jpg';
import prod4 from './assets/products/prod4.jpg';
import prod5 from './assets/products/prod5.jpg';
import prod6 from './assets/products/prod6.jpg';
import prod7 from './assets/products/prod7.jpg';
import prod8 from './assets/products/prod8.jpg';


export const sliderItems = [
    {
        id: 1,
        img: slide3,
        title: "Even more than you expected!",
        desc: "Fashion, Premium, Sneakers, Sportswear and more.",
       
    },
    {
        id: 2,
        img: slide2,
        title: "Discover your brands!",
        desc: "Discover the brands you follow. Follow brands to be the first to see their news",
        
    },
    {
        id: 3,
        img: slide1,
        title: "Free shipping and returns",
        desc: "The best things are free",
        
    },
];

export const categories = [
    {
        id: 1,
        img: boots,
        title: "NEW-SZN BOOTS",
        desc: "Be the baddie",
        
       
    },
    {
        id: 2,
        img: dress,
        title: "GLAM DRESSES",
        desc: "Amp it up",
       
    },
    {
        id: 3,
        img: outerwear,
        title: "OUTERWEAR",
        desc: "Beat-the-chill",
        
    },
];

export const products = [
    {
        id: 1,
        img: prod1,
        title: 'Black and White dress',
        price: '499.00 EUR',
        color: ['black', 'white'],
        
    
    },
    {
        id: 2,
        img: prod2,
        title: 'Be a Star Co-ord suit',
        price: '599.00 EUR',
        color: ['black', 'white'],
    },
    {
        id: 3,
        img: prod3,
        title: 'Shine Bright Co-ord suit',
        price: '599.00 EUR',
        color: ['red', 'white', 'black'],
        
    }, 
    
    {
        id: 4,
        img: prod4,
        title: 'Be an Ocean Coat',
        price: '299.00 EUR',
        color: ['blue', 'white', 'black', 'beige'],
    
    },
    {
        id: 5,
        img: prod5,
        title: 'Be YOU Co-ord set',
        price: '199.00 EUR',
        color: ['red', 'white', 'black', 'beige'],
    },
    {
        id: 6,
        img: prod6,
        title: 'Be a Sun Co-ord set',
        price: '199.00 EUR',
        color: ['yellow', 'white', 'red', 'black'],
    },
    
    
    {
        id: 7,
        img: prod7,
        title: 'Burgundy coat',
        price: '169.00 EUR',
        color: ['burgundy', 'black'],
    },
    {
        id: 8,
        img: prod8,
        title: ' Black coat',
        price: '169.00 EUR',
        color: ['burgundy', 'black'],
    
    },
   
];